// // src/App.js

// import React, { useState, useEffect, useRef } from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
// import {
//   Container,
//   Box,
//   Typography,
//   AppBar,
//   Toolbar,
//   Avatar,
//   Menu,
//   MenuItem,
//   IconButton,
//   Divider,
//   CircularProgress,
//   useMediaQuery,
//   Paper,
//   BottomNavigation,
//   BottomNavigationAction,
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Fab,
//   Dialog,
//   Button,
//   Slide,
//   DialogTitle,
//   DialogContent,
//   DialogActions
// } from '@mui/material';
// import { useTheme } from '@mui/material/styles';

// // Icons for our user interface
// import {
//   AccountCircle as AccountIcon,
//   Logout as LogoutIcon,
//   Settings as SettingsIcon,
//   Dashboard as DashboardIcon,
//   AccountBalance as BudgetIcon,
//   Receipt as TransactionIcon,
//   Menu as MenuIcon,
//   Add as AddIcon,
//   Error as ErrorIcon,
//   Refresh as RefreshIcon,
//   Close as CloseIcon
// } from '@mui/icons-material';

// // Import our component views
// import { DashboardSummary } from './components/Dashboard/Summary';
// import { DashboardCharts } from './components/Dashboard/Charts';
// import { DashboardActivity } from './components/Dashboard/Activity';
// import { BudgetList } from './components/Budget/BudgetList';
// import { TransactionList } from './components/Transaction/TransactionList';
// import { LoginForm } from './components/Auth/LoginForm';
// import { RegisterForm } from './components/Auth/RegisterForm';

// // Import our context providers and hooks
// import { AuthProvider, useAuth } from './contexts/AuthContext';
// import { BudgetProvider, useBudget } from './contexts/BudgetContext';
// import { formatCurrency } from './utils/helpers';
// import ProtectedRoute from './components/Auth/ProtectedRoute';

// // Import forms
// import TransactionForm from './components/Transaction/TransactionForm';
// import { BudgetForm } from './components/Budget/BudgetForm';

// import { ThemeProvider, useThemeContext } from './contexts/ThemeContext';

// // Import the ThemeToggle component
// import ThemeToggle from './components/UI/ThemeToggle';
// import { TransactionProvider } from './contexts/TransactionContext';
// import './styles/chartStyles.css';
// import LandingPage from './components/Landing/LandingPage';
// import { SubscriptionProvider } from './contexts/SubscriptionContext';
// import PricingPlans from './components/Subscription/PricingPlans';
// import Checkout from './components/Subscription/Checkout';
// import SubscriptionRoute from './components/Auth/SubscriptionRoute';
// import { BlindsIcon, ReceiptIcon, Split } from 'lucide-react';
// import ReceiptsManagement from './components/Receipts/ReceiptsManagement';
// import EmailIntegrationForm from './components/Settings/EmailIntegrationForm';

// import SplitBillDashboard from './components/SplitBill/SplitBillDahboard';
// import SplitBillDetails from './components/SplitBill/SplitBillDetails';

// // ADD: Import DateFilterProvider and MonthSelector
// import { DateFilterProvider, useDateFilter } from './contexts/DateFilterContext';
// import MonthSelector from './components/Dashboard/MonthSelector';

// // Global Error Boundary Component
// class ErrorBoundary extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = { hasError: false, error: null, errorInfo: null };
//     console.log('ErrorBoundary initialized');
//   }

//   static getDerivedStateFromError(error) {
//     console.error('Error caught by ErrorBoundary:', error);
//     return { hasError: true, error };
//   }

//   componentDidCatch(error, errorInfo) {
//     this.setState({ errorInfo });
//     console.error("React error boundary caught an error:", error, errorInfo);
//   }

//   render() {
//     if (this.state.hasError) {
//       return (
//         <Box sx={{ 
//           p: 4, 
//           textAlign: 'center', 
//           minHeight: '100vh',
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'center',
//           alignItems: 'center',
//           bgcolor: 'background.default',
//           color: 'text.primary',
//           transition: 'background-color 0.3s, color 0.3s'
//         }}>
//           <ErrorIcon color="error" sx={{ fontSize: 60, mb: 2 }} />
//           <Typography variant="h4" gutterBottom color="error">
//             Something went wrong
//           </Typography>
//           <Typography variant="body1" sx={{ mb: 2 }}>
//             The application encountered an unexpected error.
//           </Typography>
//           <Button 
//             variant="contained" 
//             startIcon={<RefreshIcon />}
//             onClick={() => window.location.reload()}
//             sx={{ mb: 3 }}
//           >
//             Reload Application
//           </Button>
//           <Paper 
//             elevation={3} 
//             sx={{ 
//               width: '100%', 
//               maxWidth: 800, 
//               p: 2, 
//               mt: 2,
//               bgcolor: 'background.paper', 
//               borderRadius: 1,
//               overflow: 'auto',
//               transition: 'background-color 0.3s'
//             }}
//           >
//             <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
//               Error details:
//             </Typography>
//             <Box sx={{ textAlign: 'left', overflow: 'auto', maxHeight: '300px' }}>
//               <pre style={{ margin: 0 }}>
//                 {this.state.error?.toString()}
//               </pre>
//               {this.state.errorInfo && (
//                 <pre style={{ marginTop: '10px', fontSize: '0.8rem' }}>
//                   {this.state.errorInfo.componentStack}
//                 </pre>
//               )}
//             </Box>
//           </Paper>
//         </Box>
//       );
//     }
//     return this.props.children;
//   }
// }

// // Define transition for dialog
// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });

// // Component for enforcing theme on chart elements
// const ThemeEnforcer = () => {
//   const { themeMode } = useThemeContext();
//   const theme = useTheme();
  
//   useEffect(() => {
//     // Add data-theme attribute to body
//     document.body.setAttribute('data-theme', themeMode);
    
//     // Force direct style application to recharts elements
//     const timer = setTimeout(() => {
//       try {
//         // Update SVG elements and surfaces
//         document.querySelectorAll('.recharts-wrapper, .recharts-surface').forEach(el => {
//           el.style.setProperty('background-color', theme.palette.background.paper, 'important');
//         });
        
//         // Update text colors in SVGs
//         document.querySelectorAll('.recharts-text, .recharts-cartesian-axis-tick-value').forEach(el => {
//           el.style.setProperty('fill', theme.palette.text.primary, 'important');
//         });
        
//         // Update grid lines
//         document.querySelectorAll('.recharts-cartesian-grid line').forEach(el => {
//           el.style.setProperty('stroke', theme.palette.divider, 'important');
//         });
        
//         // Ensure card backgrounds are correct
//         document.querySelectorAll('.themed-card, .MuiCard-root').forEach(card => {
//           card.style.setProperty('background-color', theme.palette.background.paper, 'important');
//           card.style.setProperty('color', theme.palette.text.primary, 'important');
//         });
        
//         console.log('Applied direct styles to themed elements');
//       } catch (e) {
//         console.error('Error applying theme styles:', e);
//       }
//     }, 150);
    
//     return () => clearTimeout(timer);
//   }, [themeMode, theme]);
  
//   return null;
// };

// // Protected Layout Component that wraps authenticated pages
// const ProtectedLayout = ({ children }) => {
//   const { user, logout } = useAuth();
//   const { 
//     totalIncome, 
//     totalExpenses, 
//     monthlyBudget,
//     handleSaveTransaction,
//     handleSaveCategory,
//     categories
//   } = useBudget();
  
//   const navigate = useNavigate();
//   const location = useLocation();
//   const theme = useTheme();
//   const { themeMode } = useThemeContext();
  
//   // Enhanced mobile detection with multiple breakpoints
//   const isXSmall = useMediaQuery('(max-width:480px)'); // Very small phones
//   const isSmall = useMediaQuery(theme.breakpoints.down('sm'));  // Small phones
//   const isMobile = useMediaQuery(theme.breakpoints.down('md')); // Tablets & phones
  
//   const [userMenu, setUserMenu] = useState(null);
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [showFab, setShowFab] = useState(false);
//   const [bottomSheetOpen, setBottomSheetOpen] = useState(false);
//   const [formType, setFormType] = useState(null); // 'budget' or 'transaction'
//   const [formData, setFormData] = useState(null);
  
//   // Calculate the current balance and budget remaining
//   const balance = totalIncome - totalExpenses;
//   const budgetRemaining = monthlyBudget - totalExpenses;

//   // Get current route for bottom navigation
//   const getCurrentNavValue = () => {
//     const path = location.pathname;
//     if (path === '/dashboard') return 0;
//     if (path === '/dashboard/budget') return 1;
//     if (path === '/dashboard/transactions') return 2;
//     if (path === '/dashboard/receipts') return 3;
//     if (path === '/dashboard/split-bills') return 4;

//     return 0;
//   };

//   const handleLogout = async () => {
//     try {
//       await logout();
//       navigate('/');
//     } catch (error) {
//       console.error('Logout failed:', error);
//     }
//   };
  
//   // Determine if we should show the FAB based on current route
//   useEffect(() => {
//     const path = location.pathname;
//     setShowFab(path === '/dashboard/budget' || path === '/dashboard/transactions');
//   }, [location]);
  
//   // Handle FAB click to open appropriate form
//   const handleFabClick = () => {
//     console.log('FAB clicked for:', location.pathname);
    
//     if (location.pathname === '/dashboard/budget') {
//       // Prepare budget form data
//       setFormType('budget');
//       setFormData({
//         name: '',
//         limit: 0,
//         color: '#1976d2'
//       });
//     } else if (location.pathname === '/dashboard/transactions') {
//       // Prepare transaction form data WITHOUT setting a default type
//       setFormType('transaction');
//       setFormData({
//         description: '',
//         amount: '',
//         date: new Date().toISOString().split('T')[0],
//         categoryId: categories && categories.length > 0 ? categories[0].id : '',
//         // Don't set a default type
//       });
//     }
    
//     setBottomSheetOpen(true);
//   };
  
//   // Handle direct form submission
//   const handleDirectSubmit = async (data) => {
//     try {
//       console.log('Form submitted directly:', data);
      
//       if (formType === 'budget') {
//         await handleSaveCategory(data);
//       } else if (formType === 'transaction') {
//         // Make sure we explicitly include the type
//         console.log('Transaction type:', data.type);
//         await handleSaveTransaction({
//           ...data,
//           type: data.type || 'expense' // Fallback in case type is missing
//         });
//       }
      
//       // The form will close the dialog after calling this function
//     } catch (error) {
//       console.error('Error saving form:', error);
//     }
//   };

//   return (
//     <>
//     <AppBar 
//       position="fixed" 
//       sx={{ 
//         bgcolor: theme.palette.background.paper,
//         backdropFilter: 'blur(20px)',
//         borderBottom: '1px solid',
//         borderColor: 'divider',
//         boxShadow: 'none',
//         zIndex: (theme) => theme.zIndex.drawer + 1,
//         height: isXSmall ? 56 : isMobile ? 64 : 70, // Adjust height based on device size
//         transition: 'background-color 0.3s, border-color 0.3s'
//       }}
//     >
//       <Container maxWidth="xl" disableGutters={isXSmall}>
//         <Toolbar 
//           sx={{ 
//             py: isXSmall ? 0.25 : isMobile ? 0.5 : 1,
//             px: isXSmall ? 1 : 2, // Reduce horizontal padding on very small screens
//             minHeight: isXSmall ? 56 : undefined // Override default min-height for very small screens
//           }}
//         >
//           {/* App Logo and Navigation - Title size changes based on screen size */}
//           <Box sx={{ 
//             display: 'flex', 
//             alignItems: 'center', 
//             gap: isXSmall ? 1 : 2,
//             flexGrow: 1 
//           }}>
//             {isMobile && (
//               <IconButton 
//                 edge="start" 
//                 color="inherit" 
//                 aria-label="menu"
//                 onClick={() => setDrawerOpen(true)}
//                 sx={{ 
//                   p: isXSmall ? 0.5 : 1 // Smaller padding on very small screens
//                 }}
//               >
//                 <MenuIcon fontSize={isXSmall ? "small" : "medium"} />
//               </IconButton>
//             )}
            
//             <Typography 
//               variant={isXSmall ? "subtitle1" : "h5"} 
//               component="div" 
//               sx={{ 
//                 fontWeight: 600,
//                 fontSize: isXSmall ? '1rem' : isMobile ? '1.2rem' : '1.5rem',
//                 // Gradient with better cross-browser support
//                 background: theme.palette.mode === 'dark' 
//                   ? 'linear-gradient(45deg, #90caf9, #42a5f5)' 
//                   : 'linear-gradient(45deg, #1976d2, #90caf9)',
//                 backgroundClip: 'text',
//                 WebkitBackgroundClip: 'text',
//                 MozBackgroundClip: 'text',
//                 WebkitTextFillColor: 'transparent',
//                 MozTextFillColor: 'transparent',
//                 textFillColor: 'transparent',
//                 color: 'transparent',
//                 transition: 'background 0.3s'
//               }}
//             >
//               Soldikeeper
//             </Typography>
            
//             {/* Desktop Navigation Tabs - Hidden on Mobile */}
//             {!isMobile && (
//               <Box sx={{ display: 'flex', gap: 2, ml: 2 }}>
//                 <Typography 
//                   className={location.pathname === '/dashboard' ? 'nav-item-active' : ''}
//                   variant="button" 
//                   sx={{ 
//                     cursor: 'pointer',
//                     fontWeight: location.pathname === '/dashboard' ? 600 : 400,
//                     color: location.pathname === '/dashboard' 
//                       ? (theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.main)
//                       : theme.palette.text.primary,
//                     borderBottom: location.pathname === '/dashboard' ? 2 : 0,
//                     borderColor: location.pathname === '/dashboard' 
//                       ? (theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.main)
//                       : 'transparent',
//                     pb: 0.5,
//                     transition: 'color 0.2s ease-in-out, border-color 0.2s ease-in-out',
//                   }}
//                   onClick={() => navigate('/dashboard')}
//                 >
//                   Overview
//                 </Typography>
                
//                 <Typography 
//                   className={location.pathname === '/dashboard/budget' ? 'nav-item-active' : ''}
//                   variant="button" 
//                   sx={{ 
//                     cursor: 'pointer',
//                     fontWeight: location.pathname === '/dashboard/budget' ? 600 : 400,
//                     color: location.pathname === '/dashboard/budget' 
//                       ? (theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.main)
//                       : theme.palette.text.primary,
//                     borderBottom: location.pathname === '/dashboard/budget' ? 2 : 0,
//                     borderColor: location.pathname === '/dashboard/budget' 
//                       ? (theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.main)
//                       : 'transparent',
//                     pb: 0.5,
//                     transition: 'color 0.2s ease-in-out, border-color 0.2s ease-in-out',
//                   }}
//                   onClick={() => navigate('/dashboard/budget')}
//                 >
//                   Budget
//                 </Typography>
                
//                 <Typography 
//                   className={location.pathname === '/dashboard/transactions' ? 'nav-item-active' : ''}
//                   variant="button" 
//                   sx={{ 
//                     cursor: 'pointer',
//                     fontWeight: location.pathname === '/dashboard/transactions' ? 600 : 400,
//                     color: location.pathname === '/dashboard/transactions' 
//                       ? (theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.main)
//                       : theme.palette.text.primary,
//                     borderBottom: location.pathname === '/dashboard/transactions' ? 2 : 0,
//                     borderColor: location.pathname === '/dashboard/transactions' 
//                       ? (theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.main)
//                       : 'transparent',
//                     pb: 0.5,
//                     transition: 'color 0.2s ease-in-out, border-color 0.2s ease-in-out',
//                   }}
//                   onClick={() => navigate('/dashboard/transactions')}
//                 >
//                   Transactions
//                 </Typography>

//                 <Typography 
//                 className={location.pathname === '/dashboard/receipts' ? 'nav-item-active' : ''}
//                 variant="button" 
//                 sx={{ 
//                   cursor: 'pointer',
//                   fontWeight: location.pathname === '/dashboard/receipts' ? 600 : 400,
//                   color: location.pathname === '/dashboard/receipts' 
//                     ? (theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.main)
//                     : theme.palette.text.primary,
//                   borderBottom: location.pathname === '/dashboard/receipts' ? 2 : 0,
//                   borderColor: location.pathname === '/dashboard/receipts' 
//                     ? (theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.main)
//                     : 'transparent',
//                   pb: 0.5,
//                   transition: 'color 0.2s ease-in-out, border-color 0.2s ease-in-out',
//                 }}
//                 onClick={() => navigate('/dashboard/receipts')}
//               >
//                 Receipts
//               </Typography>


//               <Typography 
//                 className={location.pathname === '/dashboard/split-bills' ? 'nav-item-active' : ''}
//                 variant="button" 
//                 sx={{ 
//                   cursor: 'pointer',
//                   fontWeight: location.pathname === '/dashboard/split-bills' ? 600 : 400,
//                   color: location.pathname === '/dashboard/split-bills' 
//                     ? (theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.main)
//                     : theme.palette.text.primary,
//                   borderBottom: location.pathname === '/dashboard/split-bills' ? 2 : 0,
//                   borderColor: location.pathname === '/dashboard/split-bills' 
//                     ? (theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.main)
//                     : 'transparent',
//                   pb: 0.5,
//                   transition: 'color 0.2s ease-in-out, border-color 0.2s ease-in-out',
//                 }}
//                 onClick={() => navigate('/dashboard/split-bills')}
//               >
//                 Split Bills
//               </Typography>


//               </Box>
//             )}
//           </Box>

//           {/* Right Side - Financial Summary and User Menu */}
//           <Box sx={{ 
//             display: 'flex', 
//             alignItems: 'center', 
//             gap: isXSmall ? 0.5 : isMobile ? 1 : 2 // Adjust spacing based on screen size
//           }}>
//             {/* Financial Summary - Hidden on Mobile */}
//             {!isMobile && (
//               <Box sx={{ 
//                 display: 'flex', 
//                 alignItems: 'center', 
//                 gap: 3,
//                 px: 3,
//                 py: 1,
//                 borderRadius: 2,
//                 bgcolor: 'background.default',
//                 transition: 'background-color 0.3s'
//               }}>
//                 <Box>
//                   <Typography variant="caption" color="text.secondary">
//                     Balance
//                   </Typography>
//                   <Typography 
//                     variant="subtitle1" 
//                     sx={{ 
//                       fontWeight: 600,
//                       color: balance >= 0 ? 'success.main' : 'error.main',
//                       transition: 'color 0.3s'
//                     }}
//                   >
//                     {formatCurrency(balance)}
//                   </Typography>
//                 </Box>
//                 <Divider orientation="vertical" flexItem />
//                 <Box>
//                   <Typography variant="caption" color="text.secondary">
//                     Budget Left
//                   </Typography>
//                   <Typography 
//                     variant="subtitle1" 
//                     sx={{ fontWeight: 600, color: 'text.secondary', transition: 'color 0.3s' }}
//                   >
//                     {formatCurrency(budgetRemaining)}
//                   </Typography>
//                 </Box>
//               </Box>
//             )}

//              {/* Theme Toggle Button */}
//             <ThemeToggle />

//             {/* User Menu */}
//             <IconButton 
//               onClick={(e) => setUserMenu(e.currentTarget)}
//               sx={{ 
//                 bgcolor: 'background.default',
//                 '&:hover': { bgcolor: 'action.hover' },
//                 p: isXSmall ? 0.5 : 1, // Smaller padding on smaller screens
//                 transition: 'background-color 0.3s'
//               }}
//               aria-label="user menu"
//             >
//               <Avatar sx={{ 
//                 bgcolor: 'primary.main',
//                 width: isXSmall ? 28 : 32,
//                 height: isXSmall ? 28 : 32,
//                 transition: 'background-color 0.3s'
//               }}>
//                 {user?.name ? user.name[0].toUpperCase() : <AccountIcon fontSize={isXSmall ? "small" : "medium"} />}
//               </Avatar>
//             </IconButton>

//             <Menu
//               anchorEl={userMenu}
//               open={Boolean(userMenu)}
//               onClose={() => setUserMenu(null)}
//               transformOrigin={{ horizontal: 'right', vertical: 'top' }}
//               anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
//               PaperProps={{
//                 sx: { 
//                   mt: 1,
//                   minWidth: 200,
//                   bgcolor: 'background.paper',
//                   transition: 'background-color 0.3s'
//                 }
//               }}
//             >
//               <MenuItem disabled>
//                 <Typography variant="body2" color="text.secondary">
//                   {user?.email}
//                 </Typography>
//               </MenuItem>
//               <Divider />
//               <MenuItem onClick={() => setUserMenu(null)}>
//                 <SettingsIcon sx={{ mr: 1, fontSize: 20 }} /> Settings
//               </MenuItem>
//               <MenuItem onClick={handleLogout} sx={{ color: 'error.main' }}>
//                 <LogoutIcon sx={{ mr: 1, fontSize: 20 }} /> Logout
//               </MenuItem>
//             </Menu>
//           </Box>
//         </Toolbar>
//       </Container>
//     </AppBar>

//     {/* Mobile Drawer Menu */}
//     <Drawer
//       anchor="left"
//       open={drawerOpen}
//       onClose={() => setDrawerOpen(false)}
//       // Add swipe gesture support
//       SwipeAreaProps={{ 
//         sx: { width: isMobile ? 30 : 0 } // Only enable swipe area on mobile
//       }}
//       // Adjust drawer width based on screen size
//       PaperProps={{
//         sx: {
//           width: isXSmall ? '85%' : isSmall ? '75%' : '250px',
//           pt: 8,
//           pb: 2,
//           height: '100%',
//           bgcolor: 'background.paper',
//           color: 'text.primary',
//           transition: 'background-color 0.3s, color 0.3s',
//           // Add safe area support
//           paddingBottom: 'max(16px, env(safe-area-inset-bottom, 16px))'
//         }
//       }}
//     >
//       {/* User Info */}
//       <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2 }}>
//         <Avatar 
//           sx={{ 
//             width: isXSmall ? 56 : 64, 
//             height: isXSmall ? 56 : 64, 
//             mb: 1,
//             bgcolor: 'primary.main',
//             fontSize: isXSmall ? '1.5rem' : '2rem',
//             transition: 'background-color 0.3s'
//           }}
//         >
//           {user?.name ? user.name[0].toUpperCase() : <AccountIcon fontSize="large" />}
//         </Avatar>
//         <Typography variant="h6">{user?.name || 'User'}</Typography>
//         <Typography variant="body2" color="text.secondary">
//           {user?.email || 'user@example.com'}
//         </Typography>
        
//         {/* Financial Summary for Mobile */}
//         <Box sx={{ 
//           mt: 3,
//           p: 2,
//           bgcolor: 'background.default',
//           borderRadius: 2,
//           width: '100%',
//           transition: 'background-color 0.3s'
//         }}>
//           <Box sx={{ mb: 2 }}>
//             <Typography variant="caption" color="text.secondary">
//               Current Balance
//             </Typography>
//             <Typography 
//               variant="h6" 
//               sx={{ 
//                 fontWeight: 600,
//                 color: balance >= 0 ? 'success.main' : 'error.main',
//                 transition: 'color 0.3s'
//               }}
//             >
//               {formatCurrency(balance)}
//             </Typography>
//           </Box>
//           <Box>
//             <Typography variant="caption" color="text.secondary">
//               Budget Remaining
//             </Typography>
//             <Typography variant="h6" sx={{ fontWeight: 600 }}>
//               {formatCurrency(budgetRemaining)}
//             </Typography>
//           </Box>
//         </Box>
//       </Box>
      
//       <Divider />
      
//       {/* Navigation Links */}
//       <List>
//         <ListItem 
//           button 
//           selected={location.pathname === '/dashboard'}
//           onClick={() => {
//             navigate('/dashboard');
//             setDrawerOpen(false);
//           }}
//           sx={{ 
//             py: isXSmall ? 1.5 : 1, // Larger touch target on small devices
//             borderRadius: 1,
//             mx: 1,
//             transition: 'background-color 0.3s'
//           }}
//         >
//           <ListItemIcon>
//             <DashboardIcon color={location.pathname === '/dashboard' ? 'primary' : 'inherit'} />
//           </ListItemIcon>
//           <ListItemText primary="Overview" />
//         </ListItem>
        
//         <ListItem 
//           button 
//           selected={location.pathname === '/dashboard/budget'}
//           onClick={() => {
//             navigate('/dashboard/budget');
//             setDrawerOpen(false);
//           }}
//           sx={{ 
//             py: isXSmall ? 1.5 : 1, // Larger touch target on small devices
//             borderRadius: 1,
//             mx: 1,
//             transition: 'background-color 0.3s'
//           }}
//         >
//           <ListItemIcon>
//             <BudgetIcon color={location.pathname === '/dashboard/budget' ? 'primary' : 'inherit'} />
//           </ListItemIcon>
//           <ListItemText primary="Budget" />
//         </ListItem>
        
//         <ListItem 
//           button 
//           selected={location.pathname === '/dashboard/transactions'}
//           onClick={() => {
//             navigate('/dashboard/transactions');
//             setDrawerOpen(false);
//           }}
//           sx={{ 
//             py: isXSmall ? 1.5 : 1, // Larger touch target on small devices
//             borderRadius: 1,
//             mx: 1,
//             transition: 'background-color 0.3s'
//           }}
//         >
//           <ListItemIcon>
//             <TransactionIcon color={location.pathname === '/dashboard/transactions' ? 'primary' : 'inherit'} />
//           </ListItemIcon>
//           <ListItemText primary="Transactions" />
//         </ListItem>
//       </List>

//       {/* Navigation Links */}
//     <List>
//       {/* Your existing ListItems for Dashboard, Budget, Transactions */}
      
//       <ListItem 
//         button 
//         selected={location.pathname === '/dashboard/receipts'}
//         onClick={() => {
//           navigate('/dashboard/receipts');
//           setDrawerOpen(false);
//         }}
//         sx={{ 
//           py: isXSmall ? 1.5 : 1,
//           borderRadius: 1,
//           mx: 1,
//           transition: 'background-color 0.3s'
//         }}
//       >

        
//         <ListItemIcon>
//           <ReceiptIcon color={location.pathname === '/dashboard/receipts' ? 'primary' : 'inherit'} />
//         </ListItemIcon>
//         <ListItemText primary="Receipts" />
//       </ListItem>
//     </List>

//   <List>
//     <ListItem 
//         button 
//         selected={location.pathname === '/dashboard/split-bills'}
//         onClick={() => {
//           navigate('/dashboard/split-bills');
//           setDrawerOpen(false);
//         }}
//         sx={{ 
//           py: isXSmall ? 1.5 : 1,
//           borderRadius: 1,
//           mx: 1,
//           transition: 'background-color 0.3s'
//         }}
//       >
//         <ListItemIcon>
//           <ReceiptIcon color={location.pathname === '/dashboard/split-bills' ? 'primary' : 'inherit'} />
//         </ListItemIcon>
//         <ListItemText primary="Split" />
//       </ListItem>
//     </List>
      
//       <Divider />
      
//       <List>
//         <ListItem 
//           button 
//           onClick={() => {
//             setDrawerOpen(false);
//             // Add settings navigation if needed
//           }}
//           sx={{ 
//             py: isXSmall ? 1.5 : 1, // Larger touch target on small devices
//             borderRadius: 1,
//             mx: 1,
//             transition: 'background-color 0.3s'
//           }}
//         >
//           <ListItemIcon><SettingsIcon /></ListItemIcon>
//           <ListItemText primary="Settings" />
//         </ListItem>
        
//         <ListItem 
//           button 
//           onClick={handleLogout}
//           sx={{ 
//             color: 'error.main',
//             py: isXSmall ? 1.5 : 1, // Larger touch target on small devices
//             borderRadius: 1,
//             mx: 1,
//             transition: 'background-color 0.3s, color 0.3s'
//           }}
//         >
//           <ListItemIcon>
//             <LogoutIcon color="error" />
//           </ListItemIcon>
//           <ListItemText primary="Logout" />
//         </ListItem>
//       </List>
//     </Drawer>

//     {/* Main Content Area */}
//     <Box 
//       data-theme={themeMode} // Add this attribute for CSS targeting
//       sx={{ 
//         mt: isXSmall ? '56px' : isMobile ? '64px' : '70px',
//         mb: isMobile ? '56px' : 0,
//         py: isXSmall ? 1 : 2,
//         bgcolor: 'background.default', 
//         color: 'text.primary',
//         transition: 'background-color 0.3s ease-in-out, color 0.3s ease-in-out',
//         // Add horizontal swipe support for navigation
//         overflowX: 'hidden',
//         // Add safe area insets
//         paddingLeft: 'env(safe-area-inset-left, 0px)',
//         paddingRight: 'env(safe-area-inset-right, 0px)',
//       }}
//     >
//       <Container 
//         maxWidth="xl" 
//         sx={{ 
//           py: isXSmall ? 1 : 2,
//           px: isXSmall ? 0.5 : isMobile ? 1 : 2
//         }}
//       >
//         {children}
//       </Container>
//     </Box>
    
//     {/* Mobile Bottom Navigation */}
//     {isMobile && (
//       <Paper 
//         sx={{ 
//           position: 'fixed', 
//           bottom: 0, 
//           left: 0, 
//           right: 0,
//           borderRadius: 0,
//           zIndex: 1100,
//           boxShadow: 3,
//           bgcolor: 'background.paper',
//           color: 'text.primary',
//           transition: 'background-color 0.3s, color 0.3s',
//           // Calculate height with safe area inset
//           height: 'calc(56px + env(safe-area-inset-bottom, 0px))'
//         }} 
//         elevation={3}
//       >
//         <BottomNavigation
//           value={getCurrentNavValue()}
//           onChange={(event, newValue) => {
//             const paths = ['/dashboard', '/dashboard/budget', '/dashboard/transactions', '/dashboard/receipts','/dashboard/split-bills'];
//             navigate(paths[newValue]);
//           }}
//           showLabels
//           sx={{ 
//             height: '100%',
//             bgcolor: 'background.paper',
//             transition: 'background-color 0.3s',
//             // Move padding to container to fix layout issues
//             '& .MuiBottomNavigationAction-root': {
//               minWidth: 0,
//               px: isXSmall ? 0 : 1, // Reduce padding on very small screens
//               py: 1,
//               // Add active indicator
//               '&.Mui-selected': {
//                 borderBottom: '2px solid',
//                 borderColor: 'primary.main'
//               }
//             }
//           }}
//         >
//           <BottomNavigationAction 
//             label="Overview" 
//             icon={<DashboardIcon fontSize={isXSmall ? "small" : "medium"} />} 
//           />
//           <BottomNavigationAction 
//             label="Budget" 
//             icon={<BudgetIcon fontSize={isXSmall ? "small" : "medium"} />} 
//           />
//           <BottomNavigationAction 
//             label="Transactions" 
//             icon={<TransactionIcon fontSize={isXSmall ? "small" : "medium"} />} 
//           />
//           <BottomNavigationAction 
//           label="Receipts" 
//           icon={<ReceiptIcon fontSize={isXSmall ? "small" : "medium"} />} 
//         />
//         <BottomNavigationAction 
//           label="Split Bills" 
//           icon={<Split fontSize={isXSmall ? "small" : "medium"} />} 
//         />
//         </BottomNavigation>

        
//       </Paper>
//     )}
    
//     {/* Floating Action Button for adding new budgets/transactions */}
//     {isMobile && showFab && (
//       <Fab 
//         color="primary" 
//         aria-label="add" 
//         size={isXSmall ? "medium" : "large"}
//         sx={{ 
//           position: 'fixed', 
//           right: isXSmall ? 12 : 16, 
//           // Adjust bottom position to account for safe area
//           bottom: 'calc(72px + env(safe-area-inset-bottom, 0px))',
//           zIndex: 1200,
//           // Enhance touch target size
//           width: isXSmall ? 48 : 56,
//           height: isXSmall ? 48 : 56,
//           // Enhanced styling for both modes
//           boxShadow: theme.palette.mode === 'dark' 
//             ? '0 4px 20px rgba(144, 202, 249, 0.4)' 
//             : '0 4px 20px rgba(25, 118, 210, 0.2)',
//           transition: 'box-shadow 0.3s'
//         }}
//         onClick={handleFabClick}
//       >
//         <AddIcon />
//       </Fab>
//     )}
    
//     {/* Dialog Bottom Sheet for Forms */}
//     <Dialog
//       open={bottomSheetOpen}
//       onClose={() => setBottomSheetOpen(false)}
//       TransitionComponent={Transition}
//       fullWidth
//       // Use fullScreen on smaller devices for better UX
//       fullScreen={isXSmall}
//       maxWidth="sm"
//       PaperProps={{
//         sx: {
//           // Use different styles based on screen size
//           ...(isXSmall ? {
//             // Full screen style for very small devices
//             m: 0,
//             borderRadius: 0,
//             height: '100%'
//           } : {
//             // Bottom sheet style for larger mobiles and tablets
//             borderTopLeftRadius: 16,
//             borderTopRightRadius: 16,
//             position: isMobile ? 'absolute' : 'relative',
//             bottom: isMobile ? 0 : 'auto',
//             m: isMobile ? 0 : 2,
//             width: isMobile ? '100%' : 'auto',
//             maxHeight: isMobile ? '90vh' : '80vh',
//           }),
//           bgcolor: 'background.paper',
//           color: 'text.primary',
//           transition: 'background-color 0.3s, color 0.3s',
//           overflowY: 'auto'
//         }
//       }}
//     >
//       <DialogTitle sx={{ 
//         borderBottom: '1px solid', 
//         borderColor: 'divider',
//         fontSize: isXSmall ? '1rem' : isMobile ? '1.1rem' : '1.25rem',
//         py: isXSmall ? 1.5 : 2,
//         // Add close button for fullscreen mobile view
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center'
//       }}>
//         {formType === 'budget' ? 'Add New Budget Category' : 'Add New Transaction'}
        
//         {/* Add X close button for better mobile UX */}
//         {isXSmall && (
//           <IconButton 
//             edge="end" 
//             color="inherit" 
//             onClick={() => setBottomSheetOpen(false)} 
//             aria-label="close"
//             sx={{ ml: 2 }}
//           >
//             <CloseIcon />
//           </IconButton>
//         )}
//       </DialogTitle>
      
//       <DialogContent sx={{ 
//         py: isXSmall ? 2 : 3,
//         px: isXSmall ? 2 : 3,
//         // Make form elements larger on mobile for better touch targets
//         '& .MuiFormControl-root': {
//           my: isXSmall ? 1.5 : 1
//         },
//         '& .MuiInputBase-root': {
//           fontSize: isXSmall ? '1rem' : undefined,
//         },
//         '& .MuiInputLabel-root': {
//           fontSize: isXSmall ? '0.9rem' : undefined,
//         },
//         // Better spacing for mobile inputs
//         '& .MuiButton-root': {
//           my: isXSmall ? 1 : 0.5,
//           py: isXSmall ? 1.5 : 1, // Taller buttons for better touch targets
//         }
//       }}>
//         {formType === 'budget' && formData && (
//           <BudgetForm 
//             initialData={formData}
//             onSubmit={(data) => {
//               handleDirectSubmit(data);
//               setBottomSheetOpen(false);
//             }}
//           />
//         )}
        
//         {formType === 'transaction' && formData && (
//           <TransactionForm
//             initialData={formData}
//             categories={categories || []}
//             onSubmit={(data) => {
//               handleDirectSubmit(data);
//               setBottomSheetOpen(false);
//             }}
//           />
//         )}
//       </DialogContent>

//       <DialogActions sx={{ 
//         px: isXSmall ? 2 : 3, 
//         py: isXSmall ? 1.5 : 2, 
//         borderTop: '1px solid', 
//         borderColor: 'divider',
//         // Fixed bottom positioning for fullscreen mode on small devices
//         ...(isXSmall ? {
//           position: 'sticky',
//           bottom: 0,
//           bgcolor: 'background.paper',
//           zIndex: 1,
//         } : {}),
//         paddingBottom: isMobile ? 'max(16px, env(safe-area-inset-bottom, 16px))' : 16,
//         // Make buttons larger and full width on small screens
//         flexDirection: isXSmall ? 'column' : 'row',
//         '& .MuiButton-root': {
//           ...(isXSmall ? {
//             width: '100%',
//             mb: 1
//           } : {})
//         }
//       }}>
//         {/* For very small screens, change order and make Save button primary and on top */}
//         {isXSmall ? (
//           <>
//             <Button 
//               variant="contained"
//               onClick={() => {
//                 const form = document.querySelector('form');
//                 if (form) {
//                   const event = new Event('submit', {bubbles: true, cancelable: true});
//                   form.dispatchEvent(event);
//                 }
//               }}
//               sx={{ py: 1.5 }} // Taller button for better touch target
//             >
//               Save
//             </Button>
//             <Button 
//               onClick={() => setBottomSheetOpen(false)} 
//               color="inherit"
//               sx={{ py: 1.5 }} // Taller button for better touch target
//             >
//               Cancel
//             </Button>
//           </>
//         ) : (
//           <>
//             <Button 
//               onClick={() => setBottomSheetOpen(false)} 
//               color="inherit"
//             >
//               Cancel
//             </Button>
//             <Button 
//               variant="contained"
//               onClick={() => {
//                 const form = document.querySelector('form');
//                 if (form) {
//                   const event = new Event('submit', {bubbles: true, cancelable: true});
//                   form.dispatchEvent(event);
//                 }
//               }}
//             >
//               Save
//             </Button>
//           </>
//         )}
//       </DialogActions>
//     </Dialog>
    
//     {/* Theme Enforcer Component - This explicitly applies theme to chart elements */}
//     <ThemeEnforcer />
//     </>
//   );
// };

// // Responsive Loading Component
// const ResponsiveLoadingIndicator = () => {
//   const theme = useTheme();
//   const isXSmall = useMediaQuery('(max-width:480px)');
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
//   return (
//     <Box sx={{ 
//       display: 'flex', 
//       flexDirection: 'column', 
//       alignItems: 'center', 
//       justifyContent: 'center',
//       py: isXSmall ? 4 : isMobile ? 6 : 8,
//       // Add subtle animation for better UX while waiting
//       animation: 'pulse 1.5s infinite ease-in-out',
//       '@keyframes pulse': {
//         '0%': { opacity: 0.6 },
//         '50%': { opacity: 1 },
//         '100%': { opacity: 0.6 }
//       }
//     }}>
//       <CircularProgress 
//         size={isXSmall ? 32 : isMobile ? 36 : 40} 
//         thickness={isXSmall ? 5 : 4} // Thicker lines on mobile for better visibility
//       />
//       <Typography 
//         variant={isXSmall ? "body2" : "body1"} 
//         sx={{ 
//           mt: 2,
//           fontWeight: 500,
//           textAlign: 'center',
//           px: 2
//         }}
//       >
//         Loading...
//       </Typography>
//     </Box>
//   );
// };

// // UPDATED: View Components that use the date filter context for month-specific data
// const DashboardView = () => {
//   const { 
//     transactions, 
//     categories,
//     loading,
//     error
//   } = useBudget();
  
//   // ADD: Import the date filter hook
//   const { 
//     filterTransactionsByMonth, 
//     getMonthStats, 
//     currentPeriodDisplay 
//   } = useDateFilter();
  
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const isXSmall = useMediaQuery('(max-width:480px)');

//   // UPDATED: Filter transactions and calculate stats for selected month
//   const monthTransactions = filterTransactionsByMonth(transactions);
//   const monthStats = getMonthStats(transactions);

//   // Show error state if we have one
//   if (error) {
//     return (
//       <Box sx={{ textAlign: 'center', py: 4 }}>
//         <Typography variant="h6" color="error" gutterBottom>
//           Error loading dashboard data
//         </Typography>
//         <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//           {error.toString()}
//         </Typography>
//         <Button 
//           variant="outlined"
//           onClick={() => window.location.reload()}
//           sx={{ py: isXSmall ? 1.5 : 1 }} // Larger touch target on mobile
//         >
//           Retry
//         </Button>
//       </Box>
//     );
//   }

//   // Show loading state with enhanced component
//   if (loading) {
//     return <ResponsiveLoadingIndicator />;
//   }

//   return (
//     <Box sx={{ display: 'flex', flexDirection: 'column', gap: isXSmall ? 1.5 : isMobile ? 2 : 3 }}>
//       {/* ADD: Month Selector */}
//       <MonthSelector />
      
//       {/* UPDATED: Pass month-specific data */}
//       <DashboardSummary
//         transactions={monthTransactions}  // Pass filtered transactions
//         categories={categories}
//         // Remove totalIncome, totalExpenses, monthlyBudget - let Summary calculate them
//       />
//       <DashboardCharts 
//         transactions={monthTransactions}  // Pass filtered transactions
//         categories={categories}
//       />
//       <DashboardActivity 
//         transactions={monthTransactions.slice(0, isXSmall ? 8 : isMobile ? 10 : 15)}  // Use filtered data
//         categories={categories}
//       />
//     </Box>
//   );
// };

// const BudgetView = () => {
//   const { 
//     categories, 
//     transactions, 
//     handleSaveCategory, 
//     handleDeleteCategory,
//     loading,
//     error
//   } = useBudget();
  
//   // ADD: Import the date filter hook
//   const { 
//     filterTransactionsByMonth, 
//     currentPeriodDisplay 
//   } = useDateFilter();
  
//   const isXSmall = useMediaQuery('(max-width:480px)');

//   // UPDATED: Filter transactions for selected month
//   const monthTransactions = filterTransactionsByMonth(transactions);

//   // Show error state
//   if (error) {
//     return (
//       <Box sx={{ textAlign: 'center', py: 4 }}>
//         <Typography variant="h6" color="error" gutterBottom>
//           Error loading budget data
//         </Typography>
//         <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//           {error.toString()}
//         </Typography>
//         <Button 
//           variant="outlined"
//           onClick={() => window.location.reload()}
//           sx={{ py: isXSmall ? 1.5 : 1 }} // Larger touch target on mobile
//         >
//           Retry
//         </Button>
//       </Box>
//     );
//   }

//   // Show enhanced loading state
//   if (loading) {
//     return <ResponsiveLoadingIndicator />;
//   }

//   return (
//     <Box>
//       {/* ADD: Month Selector */}
//       <MonthSelector />
      
//       {/* ADD: Period Display */}
//       <Typography variant="h4" gutterBottom sx={{ mt: 2, mb: 3 }}>
//         Budget for {currentPeriodDisplay}
//       </Typography>
      
//       {/* UPDATED: Pass filtered transactions */}
//       <BudgetList
//         categories={categories}
//         transactions={monthTransactions}  // Pass filtered transactions
//         onSaveCategory={handleSaveCategory}
//         onDeleteCategory={handleDeleteCategory}
//       />
//     </Box>
//   );
// };

// const TransactionsView = () => {
//   const { 
//     transactions, 
//     categories, 
//     handleSaveTransaction, 
//     handleDeleteTransaction,
//     loading,
//     error
//   } = useBudget();
  
//   // ADD: Import the date filter hook
//   const { 
//     filterTransactionsByMonth, 
//     currentPeriodDisplay 
//   } = useDateFilter();
  
//   const isXSmall = useMediaQuery('(max-width:480px)');

//   // UPDATED: Filter transactions for selected month
//   const monthTransactions = filterTransactionsByMonth(transactions);

//   // Show error state
//   if (error) {
//     return (
//       <Box sx={{ textAlign: 'center', py: 4 }}>
//         <Typography variant="h6" color="error" gutterBottom>
//           Error loading transaction data
//         </Typography>
//         <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//           {error.toString()}
//         </Typography>
//         <Button 
//           variant="outlined"
//           onClick={() => window.location.reload()}
//           sx={{ py: isXSmall ? 1.5 : 1 }} // Larger touch target on mobile
//         >
//           Retry
//         </Button>
//       </Box>
//     );
//   }

//   // Show enhanced loading state
//   if (loading) {
//     return <ResponsiveLoadingIndicator />;
//   }

//   return (
//     <Box>
//       {/* ADD: Month Selector */}
//       <MonthSelector />
      
//       {/* ADD: Period Display */}
//       <Typography variant="h4" gutterBottom sx={{ mt: 2, mb: 3 }}>
//         Transactions for {currentPeriodDisplay}
//       </Typography>
      
//       {/* UPDATED: Pass filtered transactions */}
//       <TransactionList
//         transactions={monthTransactions}  // Pass filtered transactions
//         categories={categories}
//         onSaveTransaction={handleSaveTransaction}
//         onDeleteTransaction={handleDeleteTransaction}
//       />
//     </Box>
//   );
// };

// // Main routing component with enhanced error handling
// const AppContent = () => {
//   const { user, loading: authLoading, error: authError } = useAuth();
//   const theme = useTheme();
//   const isXSmall = useMediaQuery('(max-width:480px)');
  
//   console.log('AppContent rendering, auth state:', { 
//     isAuthenticated: !!user, 
//     isLoading: authLoading, 
//     hasError: !!authError 
//   });

//   // Show auth error screen if authentication fails
//   if (authError) {
//     return (
//       <Box sx={{ 
//         minHeight: '100vh', 
//         display: 'flex', 
//         flexDirection: 'column',
//         alignItems: 'center', 
//         justifyContent: 'center',
//         p: 3,
//         bgcolor: 'background.default',
//         color: 'text.primary',
//         transition: 'background-color 0.3s, color 0.3s'
//       }}>
//         <Typography variant={isXSmall ? "h6" : "h5"} color="error" gutterBottom>
//           Authentication Error
//         </Typography>
//         <Typography variant="body1" align="center" sx={{ mb: 3, maxWidth: 500 }}>
//           {authError.toString()}
//         </Typography>
//         <Button 
//           variant="contained" 
//           onClick={() => window.location.href = '/login'} 
//           sx={{ mt: 2, py: isXSmall ? 1.5 : 1 }} // Enhanced touch target
//         >
//           Return to Login
//         </Button>
//       </Box>
//     );
//   }

//   // Show enhanced loading spinner while checking authentication
//   if (authLoading) {
//     return <ResponsiveLoadingIndicator />;
//   }

//   return (
//     <Routes>
//       {/* Existing routes */}
//       <Route path="/" element={<LandingPage />} />
//       <Route path="/login" element={<LoginForm />} />
//       <Route path="/register" element={<RegisterForm />} />
      
//       {/* Protected routes */}
//       <Route
//         path="/dashboard/*"
//         element={
//           <ProtectedLayout>
//             <ProtectedRoute>
//               <Routes>
//                 <Route index element={<DashboardView />} />
//                 <Route path="budget" element={<BudgetView />} />
//                 <Route path="transactions" element={<TransactionsView />} />
                
//                 {/* Add new receipt management routes */}
//                 <Route path="receipts" element={<ReceiptsManagement />} />
//                 <Route path="split-bills" element={<SplitBillDashboard />} />
//                 <Route path="split-bills/:id" element={<SplitBillDetails />} />
                
//                 {/* Other routes */}
//               </Routes>
//             </ProtectedRoute>
//           </ProtectedLayout>
//         }
//       />
      
//       {/* Settings routes */}
//       <Route
//         path="/settings/*"
//         element={
//           <ProtectedLayout>
//             <ProtectedRoute>
//               <Routes>
//                 {/* Add email integration settings route */}
//                 <Route path="email-integration" element={<EmailIntegrationForm />} />
                
//                 {/* Other settings routes */}
//               </Routes>
//             </ProtectedRoute>
//           </ProtectedLayout>
//         }
//       />
      
//       {/* Default routes */}
//       <Route path="*" element={<Navigate to="/" replace />} />
//     </Routes>
//   );
// };

// // Simple fallback component for critical errors
// const AppErrorFallback = () => {
//   const isXSmall = useMediaQuery('(max-width:480px)');
//   const theme = useTheme();
  
//   return (
//     <Box 
//       sx={{ 
//         minHeight: '100vh', 
//         display: 'flex', 
//         flexDirection: 'column',
//         alignItems: 'center', 
//         justifyContent: 'center',
//         p: 3,
//         bgcolor: 'background.default',
//         color: 'text.primary',
//         transition: 'background-color 0.3s, color 0.3s'
//       }}
//     >
//       <Typography variant={isXSmall ? "h5" : "h4"} gutterBottom color="error">
//         Application Error
//       </Typography>
//       <Typography variant="body1" align="center" sx={{ mb: 3, maxWidth: 500 }}>
//         The application has encountered a critical error and cannot continue.
//       </Typography>
//       <Button 
//         variant="contained" 
//         onClick={() => window.location.reload()}
//         sx={{ py: isXSmall ? 1.5 : 1 }} // Enhanced touch target
//       >
//         Reload Application
//       </Button>
//     </Box>
//   );
// };

// // Main App component with context providers and error boundary
// function App() {
//   console.log('App component initializing');
  
//   // Use state to track critical errors
//   const [hasCriticalError, setHasCriticalError] = useState(false);
  
//   // Error handler for unhandled errors
//   useEffect(() => {
//     const handleGlobalError = (event) => {
//       console.error('Unhandled global error:', event);
//       setHasCriticalError(true);
//       event.preventDefault();
//     };
    
//     window.addEventListener('error', handleGlobalError);
//     window.addEventListener('unhandledrejection', handleGlobalError);
    
//     return () => {
//       window.removeEventListener('error', handleGlobalError);
//       window.removeEventListener('unhandledrejection', handleGlobalError);
//     };
//   }, []);
  
//   // Show a simple fallback for critical errors
//   if (hasCriticalError) {
//     return <AppErrorFallback />;
//   }

//   // UPDATED: Add DateFilterProvider to the context stack
//   return (
//     <ErrorBoundary>
//       <ThemeProvider>
//         <AuthProvider>
//           <SubscriptionProvider>
//             <BudgetProvider>
//               <TransactionProvider>
//                 <DateFilterProvider>  {/* ADD THIS LINE */}
//                   <Router>
//                     <AppContent />
//                   </Router>
//                 </DateFilterProvider>  {/* ADD THIS LINE */}
//               </TransactionProvider>
//             </BudgetProvider>
//           </SubscriptionProvider>
//         </AuthProvider>
//       </ThemeProvider>
//     </ErrorBoundary>
//   );
// }

// export default App;

// src/contexts/DateFilterContext.js
import React, { createContext, useContext, useState, useMemo, useCallback, useEffect } from 'react';

// Create the context
const DateFilterContext = createContext();

// Custom hook to use the context
export const useDateFilter = () => {
  const context = useContext(DateFilterContext);
  if (!context) {
    throw new Error('useDateFilter must be used within a DateFilterProvider');
  }
  return context;
};

// Helper: Load from localStorage with fallback
const loadFromStorage = (key, defaultValue) => {
  try {
    const stored = localStorage.getItem(key);
    return stored ? JSON.parse(stored) : defaultValue;
  } catch {
    return defaultValue;
  }
};

// Provider component
export const DateFilterProvider = ({ children }) => {
  const currentDate = useMemo(() => new Date(), []);
  
  // State for selected month and year (existing behavior)
  const [selectedMonth, setSelectedMonth] = useState(currentDate.getMonth());
  const [selectedYear, setSelectedYear] = useState(currentDate.getFullYear());
  
  // NEW: State for filter mode ('month' or 'range')
  const [filterMode, setFilterMode] = useState(() => 
    loadFromStorage('dateFilterMode', 'month')
  );
  
  // NEW: State for date range
  const [dateRange, setDateRange] = useState(() => {
    const stored = loadFromStorage('dateRange', null);
    if (stored && stored.start && stored.end) {
      return {
        start: new Date(stored.start),
        end: new Date(stored.end)
      };
    }
    return { start: null, end: null };
  });

  // Persist filterMode and dateRange to localStorage
  useEffect(() => {
    localStorage.setItem('dateFilterMode', filterMode);
  }, [filterMode]);

  useEffect(() => {
    if (dateRange.start || dateRange.end) {
      localStorage.setItem('dateRange', JSON.stringify({
        start: dateRange.start?.toISOString(),
        end: dateRange.end?.toISOString()
      }));
    }
  }, [dateRange]);

  // Helper function to get month name
  const getMonthName = useCallback((monthIndex) => {
    return new Date(0, monthIndex).toLocaleString('default', { month: 'long' });
  }, []);

  // NEW: Computed effective dates based on mode
  // When in 'range' mode, return selected range
  // When in 'month' mode, compute start = first day of month, end = last day of month
  const effectiveStartDate = useMemo(() => {
    if (filterMode === 'range') return dateRange.start;
    // Month mode: first day of selected month
    return new Date(selectedYear, selectedMonth, 1);
  }, [filterMode, dateRange.start, selectedMonth, selectedYear]);

  const effectiveEndDate = useMemo(() => {
    if (filterMode === 'range') return dateRange.end;
    // Month mode: last day of selected month
    return new Date(selectedYear, selectedMonth + 1, 0, 23, 59, 59, 999);
  }, [filterMode, dateRange.end, selectedMonth, selectedYear]);

  // Computed values
  const currentPeriodDisplay = useMemo(() => {
    if (filterMode === 'range') {
      return formatDateRange(dateRange.start, dateRange.end);
    }
    return `${getMonthName(selectedMonth)} ${selectedYear}`;
  }, [filterMode, dateRange, selectedMonth, selectedYear, getMonthName]);

  const isCurrentMonth = useMemo(() => {
    if (filterMode === 'range') return false; // N/A for range mode
    return selectedMonth === currentDate.getMonth() && 
           selectedYear === currentDate.getFullYear();
  }, [filterMode, selectedMonth, selectedYear, currentDate]);

  // Navigation functions
  const goToPreviousMonth = useCallback(() => {
    setFilterMode('month'); // Switch to month mode when using navigation
    if (selectedMonth === 0) {
      setSelectedMonth(11);
      setSelectedYear(prev => prev - 1);
    } else {
      setSelectedMonth(prev => prev - 1);
    }
  }, [selectedMonth]);

  const goToNextMonth = useCallback(() => {
    setFilterMode('month'); // Switch to month mode when using navigation
    if (selectedMonth === 11) {
      setSelectedMonth(0);
      setSelectedYear(prev => prev + 1);
    } else {
      setSelectedMonth(prev => prev + 1);
    }
  }, [selectedMonth]);

  const goToCurrentMonth = useCallback(() => {
    setFilterMode('month'); // Switch to month mode
    setSelectedMonth(currentDate.getMonth());
    setSelectedYear(currentDate.getFullYear());
  }, [currentDate]);

  const setSpecificMonth = useCallback((month, year) => {
    setFilterMode('month'); // Switch to month mode
    setSelectedMonth(month);
    setSelectedYear(year);
  }, []);

  // NEW: Custom range functions
  const setCustomRange = useCallback((start, end) => {
    setFilterMode('range');
    setDateRange({ start, end });
  }, []);

  const setPresetRange = useCallback((preset) => {
    const today = new Date();
    today.setHours(23, 59, 59, 999); // End of today
    let start, end;
    
    switch(preset) {
      case 'last7days':
        start = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
        start.setHours(0, 0, 0, 0);
        end = today;
        break;
      case 'last30days':
        start = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000);
        start.setHours(0, 0, 0, 0);
        end = today;
        break;
      case 'last3months':
        start = new Date(today.getFullYear(), today.getMonth() - 3, 1);
        start.setHours(0, 0, 0, 0);
        end = today;
        break;
      case 'thisYear':
        start = new Date(today.getFullYear(), 0, 1);
        start.setHours(0, 0, 0, 0);
        end = today;
        break;
      case 'allTime':
        start = null; // No start filter
        end = null;   // No end filter
        break;
      default:
        return;
    }
    
    setCustomRange(start, end);
  }, [setCustomRange]);

  const switchToMonthMode = useCallback(() => {
    setFilterMode('month');
  }, []);

  // Transaction filtering functions (UPDATED to support date ranges)
  const filterTransactionsByMonth = useCallback((transactions) => {
    if (!transactions || !Array.isArray(transactions)) return [];
    
    return transactions.filter(transaction => {
      if (!transaction.date) return false;
      
      // Use budgetMonth if available, otherwise fall back to date
      const monthToCheck = transaction.budgetMonth 
        ? new Date(transaction.budgetMonth + '-01')
        : new Date(transaction.date);
      
      if (isNaN(monthToCheck.getTime())) return false;
      
      // If in range mode with no dates set (All Time), include all
      if (filterMode === 'range' && !effectiveStartDate && !effectiveEndDate) {
        return true;
      }
      
      // Filter by effective date range (works for both month and range modes)
      if (effectiveStartDate && monthToCheck < effectiveStartDate) return false;
      if (effectiveEndDate && monthToCheck > effectiveEndDate) return false;
      
      return true;
    });
  }, [filterMode, effectiveStartDate, effectiveEndDate]);

  // Get month statistics
  const getMonthStats = useCallback((transactions) => {
    const monthTransactions = filterTransactionsByMonth(transactions);
    
    const totalIncome = monthTransactions
      .filter(t => t.type === 'income')
      .reduce((sum, t) => sum + (Number(t.amount) || 0), 0);
    
    const totalExpenses = monthTransactions
      .filter(t => t.type === 'expense' || !t.type)
      .reduce((sum, t) => sum + (Number(t.amount) || 0), 0);
    
    const netAmount = totalIncome - totalExpenses;
    
    return {
      totalIncome,
      totalExpenses,
      netAmount,
      transactionCount: monthTransactions.length,
      savingsRate: totalIncome > 0 ? (netAmount / totalIncome) * 100 : 0
    };
  }, [filterTransactionsByMonth]);

  // Context value
  const value = {
    // Current selection (existing)
    selectedMonth,
    selectedYear,
    currentPeriodDisplay,
    isCurrentMonth,
    
    // NEW: Range mode support
    filterMode,
    dateRange,
    effectiveStartDate,
    effectiveEndDate,
    
    // Helper functions
    getMonthName,
    
    // Navigation functions (existing)
    goToPreviousMonth,
    goToNextMonth,
    goToCurrentMonth,
    setSpecificMonth,
    setSelectedMonth,
    setSelectedYear,
    
    // NEW: Range mode functions
    setCustomRange,
    setPresetRange,
    switchToMonthMode,
    
    // Data filtering functions
    filterTransactionsByMonth,
    getMonthStats,
    
    // Current date for reference
    currentDate
  };

  return (
    <DateFilterContext.Provider value={value}>
      {children}
    </DateFilterContext.Provider>
  );
};

// Helper function to format date range for display
function formatDateRange(start, end) {
  if (!start && !end) return 'All Time';
  
  const opts = { month: 'short', day: 'numeric', year: 'numeric' };
  
  if (!start) return `Up to ${end.toLocaleDateString('en-US', opts)}`;
  if (!end) return `From ${start.toLocaleDateString('en-US', opts)}`;
  
  // Check if same year
  if (start.getFullYear() === end.getFullYear()) {
    const startStr = start.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    const endStr = end.toLocaleDateString('en-US', opts);
    return `${startStr} - ${endStr}`;
  }
  
  return `${start.toLocaleDateString('en-US', opts)} - ${end.toLocaleDateString('en-US', opts)}`;
}

// Default export for backward compatibility
export default DateFilterContext;